import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    loginExpiresAt: null
  },
  getters: {
    loggedIn: state => state.loginExpiresAt && state.loginExpiresAt > Date.now()
  },
  mutations: {
    setLogin (state, { expires }) {
      state.loginExpiresAt = expires;
    }
  }
});

export default store;